import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

import { TagItem } from "@components/custom/dropdowns";

import "./add-device-tag.dropdown.scss";

// Sentinel option used by the zero-state item so selecting it triggers the
// create-tag flow instead of toggling a tag.
const CREATE_TAG_OPTION = { createTag: true };

export const AddDeviceTagDropdown = ({
  selected = [],
  tags,
  onChange,
  onCreateTag,
}) => {
  const hasTags = tags?.length > 0;

  const onOptionSelected = (option) => {
    if (option?.createTag) {
      onCreateTag?.();
      return;
    }

    // Since the dropdown does not handle multi-selection we first need to know
    // what operation we're going to do. If the option already exists
    // in the current selection, we need to remove it otherwise we add it.
    const found = selected.some((s) => s.id === option.id);
    const updated = [];

    if (found) {
      updated.push(...selected.filter((s) => s.id !== option.id));
    } else {
      updated.push(...selected, option);
    }

    onChange?.(updated);
  };

  return (
    <Dropdown
      className="add-device-tag-dropdown"
      onOptionSelected={onOptionSelected}
    >
      <DropdownButton icon={["fa-regular", "plus-square"]} />
      <DropdownItems>
        {hasTags ? (
          tags.map((t) => {
            const isSelected = selected.some((s) => s.id === t.id);

            return (
              <DropdownItem
                // Include selection state in the key so the
                // item remounts when a tag is added/removed.
                key={`${t.id}-${isSelected}`}
                value={t}
                isSelected={isSelected}
              >
                <TagItem value={t} />
              </DropdownItem>
            );
          })
        ) : (
          <DropdownItem
            className="add-device-tag-zero-state"
            value={CREATE_TAG_OPTION}
          >
            <p>Please create a tag before adding one to this device.</p>
            <span className="btn">
              <FontAwesomeIcon icon={["fa-regular", "plus"]} />
              Create Tag
            </span>
          </DropdownItem>
        )}
      </DropdownItems>
    </Dropdown>
  );
};
